import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Card from "../../components/common/Card"
import PublishersTable from "./PublishersTable";

import { Container, CardWrapper } from "./PublishersStyles";
import { getTopBoard } from "../../redux/slices/publisherSlice";

const Publishers = () => {
  const dispatch = useDispatch();
  const { topBoard } = useSelector((state) => state.publisher);
  //console.log(topBoard);
  useEffect(() => {
    dispatch(getTopBoard());
  }, [dispatch]);
  return (
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Publishers</h3>
          <p>View and manage publisher profiles to optimize campaign reach and performance.</p>
        </div>

        <div className="link-buttons">
          {/* <Link className="see-more" to="/campaigns">
            Export
          </Link> */}
          <Link className="add-campaign" to="/create-publisher">
            + Add publishers
          </Link>
        </div>
      </div>
      
      <CardWrapper>
        <Card
          text={"Total no of publishers"}
          totalCount={topBoard?.totalPublisher}
        />
        <Card
          text={"Active publishers"}
          totalCount={topBoard?.activePublisher}
        />
        {/* <Card text={"Pending publishers"} totalCount={'100'} /> */}
      </CardWrapper>
      <PublishersTable />
    </Container>
  );
};

export default Publishers;
